import _ from "./underscore.js";
import baseIteratee from "./_baseIteratee.js";
export default function iteratee(value, context) {
  return baseIteratee(value, context, Infinity);
}
_.iteratee = iteratee;
